import { PayrollController } from '../../controllers';
import { amountFormatter } from '../../utils/utils';
import { array, number, object, string } from 'yup';
import { MimaToastUtil } from '../../components';
import { EmployeePayDetails } from '../../pages';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';

const EmployeePayDetailsContainer = ({ closeModal, payroll }) => {
	const [loading, setLoading] = useState(false);
	const [editState, setEditState] = useState(false);
	const [requestChange, setRequestChange] = useState(false);

	const goBack = () => {
		if (editState) {
			setEditState(false);
		} else if (requestChange) {
			setRequestChange(false);
		} else {
			closeModal();
		}
	};

	const requestChangeValidationSchema = () => {
		return object({
			comment: string().required('Please enter comment'),
		});
	};

	const onRequestChangeSubmit = async payload => {
		setLoading(true);
		const controller =
			payroll.status !== constant.STATUS.IN_REVIEW
				? 'approverRequestChange'
				: 'reviewerRequestChange';

		const { status, errorMessage } = await PayrollController[controller]({
			comment: `${payload.comment}. Change request for ${payload.employeeName}`,
			id: payroll._id,
		});
		setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		MimaToastUtil.error({
			message: errorMessage,
		});
		return closeModal();
	};
	const validationSchema = () => {
		return object({
			payDeductions: array(
				object({
					amount: number()
						.min(1, 'Minimum amount is 1')
						.required('Amount is required'),
					type: string().required('Type is required'),
				})
			),
			payAdditions: array(
				object({
					amount: number()
						.min(1, 'Minimum amount is 1')
						.required('Amount is required'),
					type: string().required('Type is required'),
				})
			),
		});
	};
	const onSubmit = async payload => {
		setLoading(true);
		payload = {
			payAdditions: payload.payAdditions.map(addition => {
				return { type: addition.type, amount: addition.amount };
			}),
			payDeductions: payload.payDeductions.map(deduction => {
				return { type: deduction.type, amount: deduction.amount };
			}),
		};
		const { status, errorMessage } = await PayrollController.updatePayroll(
			payload,
			payroll._id
		);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: status,
			});
			setLoading(false);
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};


	const goToEditState = () => {
		setEditState(!editState);
	};

	const goToRequestChangeState = () => {
		setRequestChange(!requestChange);
	};
	const addFundList = [
		'Bonus',
		'Overtime',
		'Time Off',
		'Retainer',
		'Welfare',
		'Severance',
		'Reimbursement',
		'SalaryAdvance',
		'Commission',
		'Others',
	];

	const addDeductionList = [
		'Penalty',
		'Time Off',
		'Reimbursement',
		'Welfare',
		'Loan Repayment',
		'Others',
	];

	const totalExtra = extra => {
		const totalAmount = extra.reduce(
			(previousValue, currentValue) => previousValue + currentValue.amount,
			0
		);
		return amountFormatter().format(totalAmount);
	};

	return (
		<EmployeePayDetails
			closeModal={closeModal}
			validationSchema={validationSchema}
			payroll={payroll}
			onSubmit={onSubmit}
			loading={loading}
			addFundList={addFundList}
			addDeductionList={addDeductionList}
			goBack={goBack}
			totalExtra={totalExtra}
			editState={editState}
			goToEditState={goToEditState}
			requestChange={requestChange}
			goToRequestChangeState={goToRequestChangeState}
			onRequestChangeSubmit={onRequestChangeSubmit}
			requestChangeValidationSchema={requestChangeValidationSchema}
		/>
	);
};

export default observer(EmployeePayDetailsContainer);
